<agr-form-dialog
  [formGroup]="formGroup"
  (confirm)="save()"
  (alt)="alt()"
  (cancel)="cancel()"
  [data]="data"
>
  <div formArrayName="columnSettings" class="spacing--margin-top">
    <div class="flex--column">
      <mat-slide-toggle
        [hideIcon]="true"
        *ngFor="let control of columnSettings().controls; index as i"
        [formControlName]="i"
        [checked]="control.value"
        [attr.data-test]="'column__settings-' + columnSettingsArray[i]"
        (change)="switchColumnSetting($event, columnSettingsArray[i])"
        class="spacing--margin-top"
        color="primary"
      >
        {{ 'reference-value-sheet.create.table-header.' + columnSettingsArray[i] | translate }}
      </mat-slide-toggle>
    </div>
  </div>
</agr-form-dialog>
